import axios from 'axios'

function initialState() {
  return {
    bookmarkList: [],
    isNotDuplicate: true,
    isSafetyUrlOnly: true,
    topicParts: {},
    topicCount: 0,
  }
}

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    bookmarkList: (state) => state.bookmarkList,
    isNotDuplicate: (state) => state.isNotDuplicate,
    isSafetyUrlOnly: (state) => state.isSafetyUrlOnly,
    topicParts: (state) => state.topicParts,
    topicCount: (state) => state.topicCount,
  },
  mutations: {
    bookmarkList(state, data) {
      state.bookmarkList = data.bookmark;
      state.isNotDuplicate = data.isNotDuplicate;
      state.isSafetyUrlOnly = data.isSafetyUrlOnly;
    },
    addTopicParts(state, data) {
      state.topicParts[data.id] = {'name': data.name, 'url': data.url}
      state.topicCount = Object.keys(state.topicParts).length;
    },
    deleteTopicParts(state, data) {
      delete state.topicParts[data];
      state.topicCount = Object.keys(state.topicParts).length;
    },
    resetTopic(state) {
      Object.assign(state, initialState())
    },
  },
  actions: {
    async get({commit}, data) {
			const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/format_bookmark', data, {
				headers: { 'content-type': 'multipart/form-data' }
      })
      commit('bookmarkList', response.data);
    },
    addTopicPart({commit}, data) {
      commit('addTopicParts', data);
    },
    deleteTopicPart({commit}, data) {
      commit('deleteTopicParts', data);
    },
    resetState({commit}) {
      commit('resetTopic');
    },
  }
}